// src/components/Footer.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';

const toPersianDigits = (input) => {
  const en = '0123456789';
  const fa = '۰۱۲۳۴۵۶۷۸۹';
  return String(input).replace(/\d/g, d => fa[en.indexOf(d)]);
};

const Footer = ({
  author = 'احسان فخریان',
  usePersianDigits = false, // اگر بخواهی ارقام فارسی باشد true کن
  fixed = false,           // اگر true شود فوتِر fixed می‌شود. معمولاً false بگذار
  height = 56              // ارتفاع فوتِر در حالت fixed (px)
}) => {
  const now = new Date();
  const start = now.getFullYear();
  const end = start + 1;
  const years = `${start}-${end}`;
  const displayYears = usePersianDigits ? toPersianDigits(years) : years;

  const baseSx = {
    py: 1,
    px: 2,
    bgcolor: 'background.paper',
    borderTop: theme => `1px solid ${theme.palette.divider}`,
    textAlign: 'center'
  };

  const fixedSx = fixed ? {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    height,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1200,
    px: 2
  } : {};

  return (
    <Box component="footer" sx={{ ...baseSx, ...fixedSx }} dir="rtl" aria-label="Footer">
      <Typography variant="body2" color="text.secondary">
        طراحی و پیاده‌سازی <strong>{author}</strong> — تاریخ {displayYears}
      </Typography>
    </Box>
  );
};

export default Footer;
